export default {"src":"/_next/static/media/help.bf05f8f0.svg","height":36,"width":36};